const TRUE_VALUES = new Set(['1', 'true', 'yes'])

export const ENABLE_ALL_FEATURES_FOR_TESTING_ENV = 'VITE_ENABLE_ALL_FEATURES_FOR_TESTING'

const isProdMode = () => import.meta.env.MODE === 'prod' || import.meta.env.MODE === 'production'

export const testingOverrideAllowsAllFeatures = () =>
  !isProdMode() &&
  TRUE_VALUES.has(String(import.meta.env[ENABLE_ALL_FEATURES_FOR_TESTING_ENV] ?? '').trim().toLowerCase())
